/**
 * Viewport 适配 — 统一 rem 基准
 *
 * - PC（>768px）：font-size 固定 100px，rem 与设计稿 1:1 对应
 * - 手机（≤768px）：按 375px 设计稿等比缩放
 *
 * 配合 postcss-pxtorem（rootValue: 100）和 MUI htmlFontSize: 100 使用
 */
export function initViewport() {
  const setRem = () => {
    const width = window.innerWidth;
    const base = width > 768 ? 100 : (width / 375) * 100;
    document.documentElement.style.fontSize = `${base}px`;
  };

  setRem();
  window.addEventListener('resize', setRem);
}
